import React, { useState, useEffect } from 'react';
import { Search, Upload, Download, AlertCircle, CheckCircle, XCircle, X } from 'lucide-react';
import { airlines_list } from "../../../store/Admin/Common/CommonSlice";
import { useDispatch } from "react-redux";
import axios from 'axios';
import { httpinstance } from "../../../axios/api";
import { toast, ToastContainer } from "react-toastify";
import {
  TextField,

} from "@mui/material";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL_NODE


// Utility functions
const normalizeAWB = (awbNumber) => awbNumber.replace(/[-\s]/g, '').toUpperCase();
const formatAWB = (awbNumber) => {
  const normalized = normalizeAWB(awbNumber);
  if (normalized.length >= 11) {
    return `${normalized.substring(0, 3)}-${normalized.substring(3)}`;
  }
  return normalized;
};
const extractPrefix = (awbNumber) => awbNumber.replace(/[-\s]/g, '').substring(0, 3);

// API Service
const api = {
  // async getCarrierStatistics() {
  //   const response = await fetch(`${API_BASE_URL}/statistics/carriers`);
  //   if (!response.ok) throw new Error('Failed to fetch statistics');
  //   return response.json();
  // },

  async getAWBs(params, airline_prefix) {
    const queryParams = new URLSearchParams(params);
    const response = await httpinstance.get(`/awb/status?status=${params}&airline_prefix=${airline_prefix}`);
    if (!response.ok) throw new Error('Failed to fetch AWBs');
    return response;
  },//awbno listing based on params

  // async bulkUpload(awbData) {
  //   const response = await fetch(`${API_BASE_URL}/bulk-upload`, {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ awb_data: awbData, uploaded_by: uploadedBy })
  //   });
  //   if (!response.ok) {
  //     const error = await response.json();
  //     throw new Error(error.error || 'Upload failed');
  //   }
  //   return response.json();
  // },//bulkupload

  // async blacklistAWBs(awbNumbers, reason, performedBy) {
  //   const response = await fetch(`${API_BASE_URL}/awbs/blacklist`, {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ awb_numbers: awbNumbers, reason, performed_by: performedBy })
  //   });
  //   if (!response.ok) throw new Error('Failed to blacklist AWBs');
  //   return response.json();
  // }//blacklist
};

// Carrier Card Component
const CarrierCard = ({ carrier, onClick }) => (
  <div className='bg-white  rounded-lg p-4 shadow-sm gap-4 hover:shadow-md transition-all cursor-pointer border-l-4 border-yellow-500'>

    <div className="flex justify-between items-center mb-4">
      <div className="text-lg font-semibold text-gray-900">{carrier?.carr_name}</div>
      <div className="bg-yellow-500 text-gray-900 px-3 py-1 rounded-full text-xs font-semibold">
        {carrier?.carr_code}
      </div>
    </div>
    <div
      className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-4 "
      onClick={onClick}
    >


      {/* <div className='flex'></div> */}
      {[...( carrier?.statusCounts || [])].sort((a, b) => ['available', 'used', 'blacklisted'].indexOf(a.status) - ['available', 'used', 'blacklisted'].indexOf(b.status))?.map((statusCount, index) => (

        <div className="  text-center p-3  mt-2 bg-gray-50 rounded-md">
          <div className="text-3xl font-bold text-yellow-500">
            {statusCount?.count?.toLocaleString()}
          </div>
          <div className="text-xs text-gray-500 uppercase tracking-wide mt-1 p-2 rounded-md">{statusCount?.status}</div>
        </div>


      ))}



    </div>
  </div>

);

// Modal Component
const Modal = ({ isOpen, onClose, title, children, footer }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-start justify-center pt-8 overflow-y-auto">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full mx-4 my-8 flex flex-col max-h-[90vh]">
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-sm font-medium text-yellow-700">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X size={20} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-6">
          {children}
        </div>
        {footer && (
          <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

// Bulk Upload Modal Component
const BulkUploadModal = ({ isOpen, onClose, onSuccess }) => {
  const [awbText, setAwbText] = useState('');
  const [preview, setPreview] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const dispatch = useDispatch();
  const [airLineList, setairLineList] = useState([]);
  useEffect(() => {
    dispatch(airlines_list()).then((res) => {
      setairLineList(
        res?.payload?.data?.data.map((item) => ({
          airlineName: item?.carr_name,
          label: item?.carr_code,
          value: item?._id,
        }))
      );
    });
  }, [])


  const handleInputChange = (event) => {
    event.preventDefault();
    const inputValue = event.target.value;
    const nativeEvent = event.nativeEvent;
    if (
      nativeEvent.inputType === "deleteContentBackward" ||
      nativeEvent.inputType === "deleteByCut"
    ) {
      setAwbText((prevValue) => {
        if (inputValue.trim() === "") {
          return "";
        }
        return prevValue.slice(0, -1);
      });
      return;
    }

    if (inputValue.trim() === "") {
      setAwbText("");
      return;
    }

    let formattedValue = inputValue
      .replace(/[\r\n]+/g, ",")
      .replace(/\s*,\s*/g, ",")
      .replace(/[^0-9,]/g, "")
      .trim();

    formattedValue = formattedValue
      .split(",")
      .filter((awb) => awb.trim() !== ",")
      .map((awb) => {
        if (nativeEvent.inputType !== "insertText") {
          // if (awb.length === 9) {
          //   awb = "00" + awb;
          // } else if (awb.length === 10) {
          //   awb = "0" + awb;
          // }
        }

        if (awb.length > 3 && awb[3] !== "-") {
          awb = awb.slice(0, 3) + "-" + awb.slice(3);
        }

        return awb;
      })
      .join(",");

    setAwbText(formattedValue);
  };



  function parseAwbData(input) {
    // Split input on comma
    // const items = input?.split(/[,]+/);
    const items = input?.split(/[,\s]+/);


    const awb_numbers = [];

    items?.forEach(raw => {
      // Remove all non-digits
      const digits = raw?.replace(/\D/g, "");

      // AWB must be 11 digits (3 + 8)
      // if (digits?.length === 11) {
      const prefix = digits?.substring(0, 3);
      const awb = digits?.substring(3);
      awb_numbers?.push({
        airline_prefix: prefix,
        awb_number: awb
      });
      // }
    });

    return { awb_numbers };
  }
  const handleUpload = async () => {

    if (!awbText.trim()) {
      toast.success("Please paste AWB numbers", {
        position: "top-center",
        autoClose: 8000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: { whiteSpace: "pre-line" }  // ⬅️ VERY IMPORTANT
      });

      return;
    }
    const payloaddata = parseAwbData(awbText)
    // console.log(awbText, payloaddata, "awbText")
    setIsUploading(true);
    // console.log("Calling API...");

    try {
      let response = await httpinstance.post(`/awb`, payloaddata);
      // console.log("Called API...");
      // console.log(response, "response")
      const edata = response?.data?.data?.failureAwbs || [];
      const sdata = response?.data?.data?.successAwbs || [];

      const alertMsg = [
        ...edata.map(e => `❌ ${e?.airline_prefix}-${e?.awb_number}: ${e?.reason}`),
        ...sdata.map(s => `✅ ${s?.airline_prefix}-${s?.awb_number}: Uploaded successfully`)
      ].join("\n");

      if (alertMsg) {
        toast.success(alertMsg, {
          position: "top-center",
          autoClose: 8000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: { whiteSpace: "pre-line" }  // ⬅️ VERY IMPORTANT
        });
      }


      onSuccess();
      setAwbText('');
      setPreview(null);
      onClose();
    } catch (err) {
      console.error('Error fetching carriers:', err);
      console.log("Called API error 400");
      const errors = err?.response?.data?.errors || [];
      const alertMsg = errors
        .map(e => `${e.value} → ${e.msg}`)
        .join("\n");
      toast?.error(alertMsg || "Something went wrong!", {
        position: "top-center",
        autoClose: 8000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        // theme: "colored",
      });


    } finally {
      setIsUploading(false);
    }

  };


  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Add AWB Numbers"
        footer={
          <>
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 text-xs font-medium"
            >
              Cancel
            </button>
            <button
              onClick={handleUpload}
              disabled={isUploading || !awbText.trim()}
              className="px-4 py-2 bg-yellow-100 text-yellow-800 rounded hover:bg-yellow-200 disabled:opacity-50 text-xs font-medium"
            >
              {isUploading ? 'Processing...' : 'Add AWB Numbers'}
            </button>
          </>
        }
      >
        <div className="bg-yellow-50 border-l-2 border-yellow-200 p-3 rounded mb-4 text-xs text-gray-600">
          <strong>How it works:</strong> Paste AWB numbers below (from Excel or any format). The system will automatically identify the carrier from the AWB prefix and organize them accordingly.
        </div>

        <div className="bg-yellow-50 border border-yellow-200 p-3 rounded mb-4">
          <strong className="text-xs text-gray-700">Supported Carrier Prefixes:</strong>

          <div
            className={`grid grid-cols-3 gap-2 mt-2 ${Object.keys(airLineList).length > 6 ? 'max-h-20 overflow-y-auto' : ''
              }`}
          >
            {airLineList?.map((data, index) => (
              <div
                key={data?.value}
                className="bg-white px-2 py-1 rounded text-xs border border-gray-200"
              >
                <span className="font-medium text-yellow-700">{data?.label}</span> - {data?.airlineName}
              </div>
            ))}
          </div>
        </div>


        <div className="mb-4">
          <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
            Paste AWB Numbers
          </label>
          <textarea
            value={awbText}
            // onChange={(e) => setAwbText(e.target.value)}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded text-xs font-mono min-h-[200px] focus:outline-none focus:border-yellow-300 focus:ring-2 focus:ring-yellow-100"
            placeholder="Paste AWB numbers here (any format accepted)

Examples:
157-12345678
157 12345678
15712345678
176-87654321
020-11223344

Or comma/space separated: 157-12345678, 176-87654321, 020-11223344"
          />
          <div className="text-xs text-gray-500 mt-1">
            System accepts: Hyphenated (157-12345678), spaced (157 12345678), or continuous (15712345678) formats
          </div>
        </div>

        {preview && (
          <div>
            <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
              Processing Summary
            </label>
            <div className="bg-gray-50 p-4 rounded">
              <table className="w-full text-xs">
                <thead>
                  <tr className="border-b-2 border-gray-300">
                    <th className="text-left py-2">Carrier</th>
                    <th className="text-center py-2">Count</th>
                    <th className="text-center py-2">Duplicates</th>
                    <th className="text-center py-2">Valid</th>
                  </tr>
                </thead>
                <tbody>
                  {preview.breakdown.map((item, idx) => (
                    <tr key={idx} className="border-b border-gray-200">
                      <td className="py-2">{item.carrierName} ({item.carrierCode})</td>
                      <td className="text-center py-2">{item.originalCount}</td>
                      <td className="text-center py-2 text-red-600">{item.duplicates}</td>
                      <td className="text-center py-2 text-blue-600 font-semibold">{item.uniqueCount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="mt-4 pt-4 border-t-2 border-gray-300 font-semibold text-sm space-y-1">
                <div className="flex justify-between">
                  <span>Total Numbers Found:</span>
                  <span>{preview.totalCount}</span>
                </div>
                <div className="flex justify-between">
                  <span>Valid Numbers:</span>
                  <span className="text-blue-600">{preview.validCount}</span>
                </div>
                <div className="flex justify-between">
                  <span>Duplicates/Invalid:</span>
                  <span className="text-red-600">{preview.duplicateCount}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
      <ToastContainer />
    </>
  );
};



// View AWBs Modal Component
const ViewAWBsModal = ({ isOpen, onClose, carrier, onRefresh, statusFilter, setStatusFilter }) => {
  const [awbs, setAwbs] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [statusFilter, setStatusFilter] = useState('all');
  const [searchText, setSearchText] = useState('');
  const [typedSearch, setTypedSearch] = useState('');

  const [filteredawbs, setFilteredAWBs] = useState([]);
  const [selectedAWBs, setSelectedAWBs] = useState(""); //blacklist awb no 
  const [selectedqueryId, setSelectedqueryId] = useState('');
  const [selectedairlineprefix, setSelectedairlineprefix] = useState('');
  const [selectedstatus, setSelectedstatus] = useState('');
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    page: 1
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [showBlacklistModal, setShowBlacklistModal] = useState(false);
  const [blacklistReason, setBlacklistReason] = useState('');
  console.log(awbs, "carrier")


  // --- fetch function (unchanged except it uses the passed page) ---
  const fetchAWBs = async (page = 1) => {
    if (!carrier) return;
    setLoading(true);
    try {
      // if(statusFilter==='all'||statusFilter==="available"||statusFilter==="used"||statusFilter==="blacklisted"){
      //     setCurrentPage(1);
      // }
      const response = await httpinstance.get(`/awb/status?status=${statusFilter}&airline_prefix=${carrier?.airline_prefix}&page=${page}&search=${searchText}`);
      const apiData = response?.data?.data;
      setAwbs(apiData?.data || []);
      setPagination({
        totalCount: apiData?.totalCount || 0,
        pageSize: apiData?.pageSize || 10,
        page: apiData?.page || page
      });
      // setSearchText('');
      // keep this so currentPage reflects what server returned (optional)
      // setCurrentPage(apiData?.page || page);
    } catch (error) {
      console.error('Error fetching AWBs:', error);
    } finally {
      setLoading(false);
    }
  };

  // --- effect: fetch when modal opens OR filters/search change ---
  // IMPORTANT: do NOT include currentPage here
  useEffect(() => {
    if (!isOpen || !carrier) return;
    fetchAWBs(currentPage);
  }, [isOpen, carrier, searchText, statusFilter, currentPage]);

  useEffect(() => {
    setCurrentPage(1)
  }, [statusFilter])
  // --- pagination handler used by your nav buttons ---
  const handlePageChange = (page) => {
    if (page < 1) return;
    // optionally avoid redundant fetch
    if (page === currentPage) return;
    setCurrentPage(page);
    fetchAWBs(page);
  };

  // const handleSelectAll = (checked) => {
  //   if (checked) {
  //     setSelectedAWBs(awbs?.map(awb => awb?.awb_number));
  //   } else {
  //     setSelectedAWBs([]);
  //   }
  // };

  // const handleSelectAWB = (awbNumber, checked) => {
  //   if (checked) {
  //     setSelectedAWBs([...selectedAWBs, awbNumber]);
  //   } else {
  //     setSelectedAWBs(selectedAWBs?.filter(num => num !== awbNumber));
  //   }
  // };

  const handleBlacklist = async () => {
    if (selectedAWBs?.length === 0) {
      // alert('Please select at least one AWB number');
      toast.error('Please select at least one AWB number');
      return;
    }
    setShowBlacklistModal(true);
  };

  const confirmBlacklist = async () => {
    if (!blacklistReason?.trim()) {
      // alert('Please enter a reason for blacklisting');
      toast.error('Please enter a reason for blacklisting');

      return;
    }


    const payload =
    {

      awb_number: selectedAWBs,
      airline_prefix: selectedairlineprefix,
      status: "blacklisted", // "available", "used", "blacklisted",
      // queryId: "69327149ccc44b93e0575193",// deletedQueryId
      blacklist_reason: blacklistReason,
    }

    try {
      const response = await httpinstance.put('/awb/status', payload);
      console.log(response, "response")
      fetchAWBs(currentPage);
      toast.success('AWB blacklisted successfully');
      // alert(` AWB blacklisted successfully`);
      setBlacklistReason('');
      setShowBlacklistModal(false);
      setSelectedAWBs("");//[]
      // fetchAWBs(currentPage);
      onRefresh();
    } catch (error) {
      toast.error(`Failed to blacklist: ${error?.message}`);
      // alert(`Failed to blacklist: ${error?.message}`);
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      available: 'bg-green-100 text-green-700',
      used: 'bg-yellow-100 text-yellow-700',
      blacklisted: 'bg-red-100 text-red-700',
      reserved: 'bg-blue-100 text-blue-700'
    };
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${badges[status] || 'bg-gray-100 text-gray-700'}`}>
        {status}
      </span>
    );
  };
  //   const handleSearchBlur = () => {
  //   clearTimeout(window.searchDebounceTimer);

  //   window.searchDebounceTimer = setTimeout(() => {
  //     setSearchText(typedSearch);   // <-- triggers fetch
  //     setCurrentPage(1);            // reset page only once
  //     // fetchAWBs(currentPage)
  //   }, 3);
  // };
  useEffect(() => {
    const delay = setTimeout(() => {
      setSearchText(typedSearch);   // API will run based on this
      setCurrentPage(1);
    }, 3000);  // 3 seconds

    return () => clearTimeout(delay); // cleanup on each keystroke
  }, [typedSearch]);


  if (!carrier) return null;

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={`${carrier?.carr_name} (${carrier?.carr_code}) - AWB Numbers`}
      >
        <div className="mb-4">
          {/* <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search AWB numbers..."
            className="w-full px-3 py-2 border border-gray-300 rounded text-xs focus:outline-none focus:border-yellow-300 focus:ring-2 focus:ring-yellow-100"
          /> */}
          <input
            type="text"
            value={typedSearch}
            onChange={(e) => setTypedSearch(e.target.value)}
            // onBlur={handleSearchBlur}
            placeholder="Search AWB numbers..."
            className="w-full px-3 py-2 border border-gray-300 rounded text-xs"
          />

        </div>

        <div className="flex gap-0 mb-4 border-b-2 border-gray-200">
          {['all', 'available', 'used', 'blacklisted']?.map(status => (
            <button
              key={status}
              onClick={() => { setStatusFilter(status) }}
              className={`px-4 py-3 text-sm font-medium border-b-3 transition-all ${statusFilter === status
                ? 'border-yellow-500 text-yellow-600 bg-yellow-50'
                : 'border-transparent text-gray-600 hover:text-yellow-600 hover:bg-yellow-50'
                }`}
            >
              {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
            </button>
          ))}
        </div>


        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead className="bg-gray-50">
              <tr>

                <th className="p-2 text-left text-gray-500 uppercase font-medium">Sno</th>
                <th className="p-2 text-left text-gray-500 uppercase font-medium">AWB Number</th>
                <th className="p-2 text-left text-gray-500 uppercase font-medium">Status</th>
                <th className="p-2 text-left text-gray-500 uppercase font-medium">Added On</th>
                <th className="p-2 text-left text-gray-500 uppercase font-medium">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="p-8 text-center text-gray-500">
                    Loading...
                  </td>
                </tr>
              ) : awbs?.length === 0 ? (
                <tr>
                  <td colSpan="5" className="p-8 text-center text-gray-500">
                    No AWBs found
                  </td>
                </tr>
              ) : (
                (awbs)?.map(awb => (
                  <tr key={awb?._id} className="border-b border-gray-100 hover:bg-gray-50">
                    {/* <td className="p-2">
                      <input
                        type="checkbox"
                        checked={selectedAWBs?.includes(awb?.awb_number)}
                        onChange={(e) => handleSelectAWB(awb?.awb_number, e.target.checked)}
                      />
                    </td> */}
                    <td className="p-2">{awbs?.indexOf(awb) + 1 + (currentPage > 1 ? (currentPage - 1) * 10 : 0)}</td>
                    <td className="p-2 font-mono font-medium text-yellow-700">{awb?.awb_number}</td>
                    <td className="p-2">{getStatusBadge(awb?.status)}</td>
                    <td className="p-2 text-gray-600">
                      {new Date(awb?.createdAt)?.toLocaleDateString()}
                    </td>
                    <td className="p-2">
                      {awb?.status === 'available' && (
                        // hiii
                        <button
                          onClick={() => {
                            setSelectedAWBs(awb?.awb_number);//[]
                            setShowBlacklistModal(true);
                            setSelectedairlineprefix(awb?.airline_prefix);
                            setSelectedstatus(awb?.status);
                            setSelectedqueryId(awb?._id);

                          }}
                          className="px-2 py-1 bg-red-100 text-red-700 rounded text-xs hover:bg-red-200"
                        >
                          Blacklist
                        </button>
                      )}
                      {awb?.status === 'used' && awb?.used_in_query_id && (
                        <span className="text-gray-600">Query #{awb?.used_in_query_id}</span>
                      )}
                      {awb?.status === 'blacklisted' && (
                        <button
                          onClick={() => toast.info(`Reason: ${awb?.blacklist_reason || 'No reason provided'}`)}
                          className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs hover:bg-gray-200"
                        >
                          View Reason
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {pagination?.totalCount > pagination?.pageSize && (
          <div className="flex justify-center gap-2 mt-4 pt-4">
            <button
              onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
              disabled={currentPage === 1}
              className="px-3 py-1 border border-gray-300 rounded text-xs disabled:opacity-50"
            >
              ← Previous
            </button>

            {Array.from({ length: Math.ceil(pagination.totalCount / pagination.pageSize) }).map((_, idx) => (
              <button
                key={idx}
                onClick={() => handlePageChange(idx + 1)}
                className={`px-3 py-1 border rounded text-xs ${currentPage === idx + 1
                  ? "bg-yellow-500 text-gray-900 border-yellow-500"
                  : "border-gray-300 hover:bg-gray-50"
                  }`}
              >
                {idx + 1}
              </button>
            ))}

            <button
              onClick={() => handlePageChange(Math.min(currentPage + 1, Math.ceil(pagination.totalCount / pagination.pageSize)))}
              disabled={currentPage === Math.ceil(pagination.totalCount / pagination.pageSize)}
              className="px-3 py-1 border border-gray-300 rounded text-xs disabled:opacity-50"
            >
              Next →
            </button>
          </div>
        )}


      </Modal>

      {/* Blacklist Confirmation Modal */}
      <Modal
        isOpen={showBlacklistModal}
        onClose={() => {
          setShowBlacklistModal(false);
          setBlacklistReason('');
        }}
        title="Blacklist AWB Numbers"
        footer={
          <>
            <button
              onClick={() => {
                setShowBlacklistModal(false);
                setBlacklistReason('');
              }}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 text-xs"
            >
              Cancel
            </button>
            <button
              onClick={confirmBlacklist}
              className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 text-xs"
            >
              Confirm Blacklist
            </button>
          </>
        }
      >
        <div className="mb-4">
          <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
            Reason for Blacklisting *
          </label>
          <textarea
            value={blacklistReason}
            onChange={(e) => setBlacklistReason(e.target.value)}
            placeholder="Enter reason for blacklisting these AWB numbers..."
            className="w-full px-3 py-2 border border-gray-300 rounded text-xs min-h-[120px] focus:outline-none focus:border-yellow-300 focus:ring-2 focus:ring-yellow-100"
          />
        </div>
        <div className="bg-yellow-50 border border-yellow-200 p-3 rounded text-xs text-yellow-800">
          <strong>Warning:</strong> {selectedAWBs.length} AWB number(s) will be blacklisted and cannot be used in future queries.
        </div>
      </Modal>
    </>
  );
};

// Main App Component
const AwbModule = () => {

  const [carriers, setCarriers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedCarrier, setSelectedCarrier] = useState(null);
  const [statusFilter, setStatusFilter] = useState('all');

  const fetchCarriers = async () => {
    setLoading(true);
    try {
      let response = await httpinstance.get(`/awb`);
      console.log(response, "getawbdata")
      setCarriers(response?.data?.data);
    } catch (err) {
      console.error('Error fetching carriers:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCarriers();
  }, []);

  const handleViewCarrier = (carrier) => {
    console.log(carrier, "carrier");
    setSelectedCarrier(carrier);
    setShowViewModal(true);
  };
  const handleclose = () => {
    setShowViewModal(false)
    setStatusFilter('all')
  }

  return (
    <div className="min-h-screen bg-gray-50 p-5">
      <div className="mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
          <h1 className="text-2xl font-semibold text-black mb-2">
            AWB Number Management
          </h1>
          <p className="text-gray-600 text-sm">
            Manage airline waybill numbers for all carriers
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-4 mb-8">
          <button
            onClick={() => setShowUploadModal(true)}
            className="px-4 py-2 bg-yellow-100 text-yellow-800 rounded hover:bg-yellow-200 text-xs font-medium flex items-center gap-2"
          >
            <Upload size={16} />
            Add AWB Numbers
          </button>
          <button
            onClick={() => toast.info('Export functionality coming soon')}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 text-xs font-medium flex items-center gap-2"
          >
            <Download size={16} />
            Export Report
          </button>
        </div>

        {/* Carrier Cards Grid */}
        {loading ? (
          <div className="text-center py-12 text-gray-500">Loading carriers...</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-5">
            {carriers?.map(carrier => (
              <CarrierCard
                key={carrier?._id}
                carrier={carrier}
                onClick={() => handleViewCarrier(carrier)}
              />
            ))}
          </div>
        )}

        {/* Modals */}
        <BulkUploadModal
          isOpen={showUploadModal}
          onClose={() => setShowUploadModal(false)}
          onSuccess={fetchCarriers}
        />

        <ViewAWBsModal
          isOpen={showViewModal}
          onClose={handleclose}
          carrier={selectedCarrier}
          onRefresh={fetchCarriers}
          setStatusFilter={setStatusFilter}
          statusFilter={statusFilter}
        // const [statusFilter, setStatusFilter] = useState('all');
        />
      </div>
    </div>
  );
};

export default AwbModule;